import type { ShowSasCallbacks } from 'matrix-js-sdk/src/crypto-api';
import { useEffect, useRef } from 'react';

import { CrossSigningStatusEnum } from 'contexts/MatrixDeviceContext/types';
import logger from 'utils/logging/faro';

export type UseAutoConfirmSasParams = {
  sasCallbacks: ShowSasCallbacks | null;
  activeRequest: { initiatedByMe: boolean } | null;
  crossSigningStatus: CrossSigningStatusEnum;
};

const useAutoConfirmSas = ({ sasCallbacks, activeRequest, crossSigningStatus }: UseAutoConfirmSasParams) => {
  const confirmedRequestRef = useRef<typeof activeRequest>(null);

  useEffect(() => {
    if (crossSigningStatus === CrossSigningStatusEnum.VERIFIED || !activeRequest || !sasCallbacks) return;

    const isInitiatedByCurrentDevice = activeRequest.initiatedByMe;
    const isNewRequest = confirmedRequestRef.current !== activeRequest;

    if (isInitiatedByCurrentDevice && isNewRequest) {
      confirmedRequestRef.current = activeRequest;
      sasCallbacks.confirm().catch((err) => {
        logger.error('Failed to auto-confirm device verification via SAS decimal', err);
        confirmedRequestRef.current = null;
      });
    }
  }, [activeRequest, crossSigningStatus, sasCallbacks]);
};

export default useAutoConfirmSas;
